/**
 * Veinova — storefront behaviour.
 *  - Sale countdown to local midnight            [data-vn-cd-h|m|s|all]
 *  - Ship-by date with a daily cutoff hour        [data-vn-shipby][data-cutoff]
 *  - Bundle picker driving Horizon's product form  [data-vn-buy] .vn-bnd
 *  - Before / after comparison sliders            [data-vn-ba]
 */
(function () {
  'use strict';

  function pad(n) {
    return (n < 10 ? '0' : '') + n;
  }

  /* ---------- countdown ---------- */
  function tick() {
    var now = new Date();
    var midnight = new Date(now);
    midnight.setHours(24, 0, 0, 0);
    var s = Math.max(0, Math.floor((midnight - now) / 1000));
    var h = Math.floor(s / 3600);
    var m = Math.floor((s % 3600) / 60);
    var sec = s % 60;
    document.querySelectorAll('[data-vn-cd-h]').forEach(function (el) { el.textContent = pad(h); });
    document.querySelectorAll('[data-vn-cd-m]').forEach(function (el) { el.textContent = pad(m); });
    document.querySelectorAll('[data-vn-cd-s]').forEach(function (el) { el.textContent = pad(sec); });
    document.querySelectorAll('[data-vn-cd-all]').forEach(function (el) {
      el.textContent = pad(h) + ':' + pad(m) + ':' + pad(sec);
    });
  }

  /* ---------- ship-by ---------- */
  function shipBy(root) {
    root.querySelectorAll('[data-vn-shipby]').forEach(function (el) {
      var cutoff = parseInt(el.getAttribute('data-cutoff') || '14', 10);
      var d = new Date();
      if (d.getHours() >= cutoff) d.setDate(d.getDate() + 1);
      d.setDate(d.getDate() + 1);
      while (d.getDay() === 0 || d.getDay() === 6) d.setDate(d.getDate() + 1);
      el.textContent = d.toLocaleDateString(undefined, { weekday: 'long', month: 'long', day: 'numeric' });
    });
  }

  /* ---------- bundle picker ---------- */
  function renderBuyBox(box) {
    var card = box.querySelector('.vn-bnd.is-on');
    if (!card) return;

    var sub = box.querySelector('[data-vn-sub]');
    var subscribed = !!(sub && sub.checked && card.dataset.planPrice);
    var price = subscribed ? card.dataset.planPrice : card.dataset.price;
    var save = parseInt(card.dataset.save || '0', 10);

    box.querySelectorAll('[data-vn-price]').forEach(function (el) { el.textContent = price; });
    box.querySelectorAll('[data-vn-atc-price]').forEach(function (el) { el.textContent = price; });
    box.querySelectorAll('[data-vn-compare]').forEach(function (el) {
      el.textContent = card.dataset.compare || '';
      el.hidden = save <= 0;
    });
    box.querySelectorAll('[data-vn-save]').forEach(function (el) {
      el.textContent = (el.getAttribute('data-prefix') || 'SAVE') + ' ' + save + '%';
      el.hidden = save <= 0;
    });

    var variantInput = box.querySelector('[data-vn-variant-input]');
    if (variantInput) variantInput.value = card.dataset.variantId;

    var planInput = box.querySelector('[data-vn-plan-input]');
    if (planInput) {
      planInput.disabled = !subscribed;
      planInput.value = subscribed ? sub.value : '';
    }

    var atc = box.querySelector('.vn-atc');
    if (atc) atc.disabled = card.hasAttribute('disabled');

    // Keep Horizon's sticky add-to-cart bar in step with the chosen bundle.
    var section = box.closest('.shopify-section');
    var sticky = section && section.querySelector('sticky-add-to-cart');
    if (sticky) {
      sticky.dataset.currentVariantId = card.dataset.variantId;
      var sp = sticky.querySelector('.sticky-add-to-cart__price');
      if (sp) sp.textContent = price;
      var sv = sticky.querySelector('.sticky-add-to-cart__variant');
      if (sv) sv.textContent = card.dataset.label || '';
    }
  }

  function selectBundle(card) {
    var box = card.closest('[data-vn-buy]');
    if (!box || card.hasAttribute('disabled')) return;
    box.querySelectorAll('.vn-bnd').forEach(function (c) {
      var on = c === card;
      c.classList.toggle('is-on', on);
      c.setAttribute('aria-checked', on ? 'true' : 'false');
      c.tabIndex = on ? 0 : -1;
    });
    renderBuyBox(box);
  }

  document.addEventListener('click', function (e) {
    var card = e.target.closest && e.target.closest('.vn-bnd');
    if (card) selectBundle(card);
  });

  document.addEventListener('keydown', function (e) {
    var card = e.target.closest && e.target.closest('.vn-bnd');
    if (!card || (e.key !== 'ArrowDown' && e.key !== 'ArrowUp' && e.key !== 'ArrowRight' && e.key !== 'ArrowLeft')) return;
    e.preventDefault();
    var cards = Array.prototype.slice.call(card.closest('[data-vn-buy]').querySelectorAll('.vn-bnd:not([disabled])'));
    var i = cards.indexOf(card) + (e.key === 'ArrowDown' || e.key === 'ArrowRight' ? 1 : -1);
    var next = cards[(i + cards.length) % cards.length];
    selectBundle(next);
    next.focus();
  });

  document.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('[data-vn-sub]')) {
      var box = e.target.closest('[data-vn-buy]');
      if (box) renderBuyBox(box);
    }
  });

  /* ---------- before / after ---------- */
  function bindSliders(root) {
    root.querySelectorAll('[data-vn-ba]').forEach(function (el) {
      if (el.dataset.vnBaReady === 'true') return;
      el.dataset.vnBaReady = 'true';
      var input = el.querySelector('input[type="range"]');
      if (!input) return;
      var sync = function () { el.style.setProperty('--vn-split', input.value + '%'); };
      input.addEventListener('input', sync);
      sync();
    });
  }

  function init(root) {
    shipBy(root);
    bindSliders(root);
    root.querySelectorAll('[data-vn-buy]').forEach(renderBuyBox);
  }

  tick();
  setInterval(tick, 1000);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
    tick();
  });
  document.addEventListener('shopify:block:select', function (event) {
    init(event.target.closest('.shopify-section') || document);
  });
})();
